import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=6c838dda"
import script from "./ExportButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports